import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'fixed top-0 right-0 left-0 z-23 flex h-[56px] items-center pr-2 pl-3 transition-all duration-300 md:h-30 md:justify-between md:px-10',
    logoWr: 'relative flex items-center',
    logoNaos: 'max-md:max-w-[121px]',
    logoNaosWhite: 'max-md:max-w-[121px]',
    logoBioderma: 'max-w-[103px] max-md:ml-5 md:ml-[38px] lg:max-w-[241px]',
    logoRecommend: 'max-lg:hidden',
    divider: 'ml-5 h-5 w-px bg-black md:hidden',
    cart: 'relative flex w-[38px] items-center justify-end gap-[18px] max-md:w-full max-md:justify-end md:w-[228px]',
    cartCounter:
      'bg-blue-dark absolute top-[6px] right-1 flex min-w-5 items-center justify-center gap-[1px] rounded-full border-1 border-white px-1 text-center text-[10px] text-white lg:top-[24px]',
    progress:
      'pointer-events-none absolute bottom-0 left-0 h-0 border-b-4 transition-[width] duration-150 ease-linear'
  },
  variants: {
    scrolled: {
      true: 'bg-white md:h-22',
      false: 'bg-transparent'
    },
    whiteLogo: {
      true: '',
      false: ''
    }
  },
  compoundSlots: [
    {
      slots: ['cartCounter'],
      scrolled: true,
      class: 'md:!top-[6px]'
    },
    {
      slots: ['logoNaos'],
      scrolled: true,
      class: 'gap-[14px]'
    },
    {
      slots: ['logoBioderma'],
      scrolled: true,
      class: 'lg:h-10'
    },
    {
      slots: ['logoRecommend'],
      scrolled: true,
      class: 'md:h-[45px]'
    },
    {
      slots: ['logoNaosWhite'],
      whiteLogo: true,
      scrolled: false,
      class: 'md:hidden'
    },
    {
      slots: ['logoNaosWhite'],
      whiteLogo: true,
      scrolled: true,
      class: 'hidden'
    },
    {
      slots: ['logoNaosWhite'],
      whiteLogo: false,
      class: 'hidden'
    },
    {
      slots: ['logoNaos'],
      whiteLogo: true,
      scrolled: false,
      class: 'max-md:hidden'
    }
  ],
  defaultVariants: {
    scrolled: false,
    whiteLogo: false
  }
});
